import logger from 'lib/logger';

export function sendTmrGoal({ goal, value }: { goal: string; value?: number }) {
    logger.info('_tmr reachGoal', goal, value);

    if (window._tmr) {
        window._tmr.push({ id: '2435029', type: 'reachGoal', goal, value });
    }
}
